import { SharedReportLinkRecipient } from "../../../../../types";

export type RecipientsTableFilter = {
  email: string;
  not_viewed_report_only: boolean;
};

export const initFilter: RecipientsTableFilter = {
  email: "",
  not_viewed_report_only: false,
};

export const filterRecipients = (
  recipients: SharedReportLinkRecipient[],
  filter: RecipientsTableFilter,
): SharedReportLinkRecipient[] => {
  const trimmedLowercaseEmailFilter = filter.email.trim().toLowerCase();

  return recipients.filter((recipient) => {
    if (filter.not_viewed_report_only && !!recipient.last_opened) {
      return false;
    }

    if (
      trimmedLowercaseEmailFilter !== "" &&
      !recipient.email.toLowerCase().includes(trimmedLowercaseEmailFilter)
    ) {
      return false;
    }

    return true;
  });
};
